import ContentLoader from "react-content-loader";
import OwlCarousel from "../carousel";

const skeletonOptions = {
  margin: 10,
  loop: false,
  rewind: true,
  nav: true,
  dots: false,
  lazyLoad: true,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  smartSpeed: 500,
  navText: [
    '<i class="fas fa-angle-left"></i>',
    '<i class="fas fa-angle-right"></i>',
  ],
  responsive: {
    0: {
      items: 2,
      stagePadding: 0,
      autoplay: false,
    },
    576: {
      items: 2,
      stagePadding: 20,
      autoplay: false,
    },
    768: {
      items: 3,
      stagePadding: 0,
      autoplay: true,
    },
    992: {
      items: 4,
      stagePadding: 0,
      autoplay: true,
    },
    1200: {
      items: 5,
      stagePadding: 0,
      autoplay: true,
    },
  },
};

const SkeletonItem = () => (
  <div
    className="course-card m-2"
    style={{ width: "250px", marginBottom: "16px" }}
  >
    <ContentLoader
      speed={2}
      width={250}
      height={200}
      viewBox="0 0 250 200"
      backgroundColor="#2a2a2a" // dark background
      foregroundColor="#404040" // shimmer
    >
      <circle cx="125" cy="60" r="50" />
      <rect x="35" y="140" rx="4" ry="4" width="180" height="18" />
      <rect x="70" y="170" rx="4" ry="4" width="110" height="14" />
    </ContentLoader>
  </div>
);

const SkeletonCourseCard = ({ length = 7 }) => {
  return (
    <OwlCarousel className="category-carousel" options={skeletonOptions}>
      {Array.from({ length }).map((_, i) => (
        <SkeletonItem key={i} />
      ))}
    </OwlCarousel>
  );
};

export default SkeletonCourseCard;
